import { CssBaseline, ThemeProvider } from "@mui/material";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";
import { useRouteMatch } from "react-router-dom";

import { FailedPayoutModalRoutes } from "./ModalRoutes";

export function FailedPayoutContainer() {
  const match = useRouteMatch();

  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />
      <FailedPayoutModalRoutes basePath={match.url} />
    </ThemeProvider>
  );
}
